/**
 * Contact seeding for return forms reopened from an existing RMA.
 */

export function buildFullAddress({ address, address2, city, state, zip, country }) {
  return [address, address2, [city, state, zip].filter(Boolean).join(', '), country].filter(Boolean).join(', ');
}

export function buildContactFromRma(rma, type) {
  const fkKeys = { shipping: 'shipping_contact', billing: 'billing_contact', reporting: 'support_contact' };
  const fkContact = rma.get(fkKeys[type], null);

  if (fkContact && fkContact.get && fkContact.get('id')) {
    const obj = fkContact.toJS ? fkContact.toJS() : { ...fkContact };
    if (!obj.full_address_display) {
      obj.full_address_display = buildFullAddress({
        address: obj.address,
        address2: obj.address_2,
        city: obj.city,
        state: obj.state,
        zip: obj.zipcode,
        country: obj.country,
      });
    }
    return obj;
  }

  if (type === 'shipping') {
    const name = rma.get('ship_contact', '');
    const email = rma.get('ship_email', '');
    const company = rma.get('ship_company_name', '');
    const address = rma.get('ship_address', '');
    if (!name && !email && !company && !address) return null;
    return {
      id: null,
      name,
      business_name: company,
      email,
      phone1: rma.get('ship_phone', ''),
      address,
      address_2: rma.get('ship_address_2', ''),
      city: rma.get('ship_city', ''),
      state: rma.get('ship_state', ''),
      zipcode: rma.get('ship_zip', ''),
      country: rma.get('ship_country', ''),
      full_address_display: buildFullAddress({
        address,
        address2: rma.get('ship_address_2', ''),
        city: rma.get('ship_city', ''),
        state: rma.get('ship_state', ''),
        zip: rma.get('ship_zip', ''),
        country: rma.get('ship_country', ''),
      }),
      _isManualEntry: true,
    };
  }

  if (type === 'billing') {
    const name = rma.get('bill_contact', '');
    const email = rma.get('bill_email', '');
    if (!name && !email) return null;
    return {
      id: null,
      name,
      business_name: rma.get('bill_company_name', ''),
      email,
      phone1: rma.get('bill_phone', ''),
      address: rma.get('bill_address', ''),
      address_2: rma.get('bill_address_2', ''),
      city: rma.get('bill_city', ''),
      state: rma.get('bill_state', ''),
      zipcode: rma.get('bill_zip', ''),
      country: rma.get('bill_country', ''),
      full_address_display: buildFullAddress({
        address: rma.get('bill_address', ''),
        address2: rma.get('bill_address_2', ''),
        city: rma.get('bill_city', ''),
        state: rma.get('bill_state', ''),
        zip: rma.get('bill_zip', ''),
        country: rma.get('bill_country', ''),
      }),
      _isManualEntry: true,
    };
  }

  if (type === 'reporting') {
    const name = rma.get('support_contact_name', '');
    const email = rma.get('support_contact_email', '');
    if (!name && !email) return null;
    return {
      id: null,
      name,
      email,
      phone1: rma.get('support_contact_phone', ''),
      _isManualEntry: true,
    };
  }

  return null;
}
